<template>
  <div>
    <slot></slot>
    <vue-prism-editor v-bind:id="id" :code="code" :language="language" :readonly="readOnly" :lineNumbers="true" />
  </div>
</template>

<script>
import 'prismjs';
import VuePrismEditor from 'vue-prism-editor';

export default {
  props: {
    code: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: 'js',
    },
    id: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    VuePrismEditor,
  },
  data() {
    return {
      test: '<body>ertertertr</body>',
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '~prismjs/themes/prism-tomorrow.css';
@import '~vue-prism-editor/dist/VuePrismEditor.css';

.btn-copy {
  position: absolute;
  top: $spacer / 2;
  right: $spacer / 2;
}
</style>
